import LoadingSpinner from '$tablet-app/src/app/components/LoadingSpinner';
import Spacer from '$tablet-app/src/app/components/Spacer';
import { Button } from '@akin-home/buttons/native';
import { Text } from '@akin-home/text/native';
import { spacing } from '@akin-home/theme';
import { StyleSheet, useWindowDimensions, View } from 'react-native';

type Props = {
  text: string;
  isSaving?: boolean;
  onPressBack?: () => any;
  onPressContinue: () => any;
};

export const BottomRow = (props: Props) => {
  const { text = '', isSaving = false, onPressBack, onPressContinue } = props;

  const { width } = useWindowDimensions();
  const isShort = width < 500;

  if (isShort) {
    return (
      <View style={[styles.container, styles.portraitContainer]}>
        <Text weight="semibold" style={styles.text}>
          {text}
        </Text>

        <View style={styles.portraitButtonContainer}>
          {onPressBack ? <BackButton onPressBack={onPressBack} /> : null}

          <ContinueButton
            onPressContinue={onPressContinue}
            isSaving={isSaving}
          />
        </View>
      </View>
    );
  } else {
    return (
      <View style={[styles.container, styles.landscapeContainer]}>
        {onPressBack ? (
          <BackButton onPressBack={onPressBack} />
        ) : (
          <Spacer width="100px" />
        )}

        <Text weight="semibold" style={styles.text}>
          {text}
        </Text>

        <ContinueButton onPressContinue={onPressContinue} isSaving={isSaving} />
      </View>
    );
  }
};

const BackButton = (props: Pick<Props, 'onPressBack'>) => {
  return (
    <Button icon="chevron-left" variant="text" onPress={props.onPressBack}>
      Back
    </Button>
  );
};

const ContinueButton = (props: Pick<Props, 'onPressContinue' | 'isSaving'>) => {
  return (
    <Button onPress={props.onPressContinue}>
      {props.isSaving ? <LoadingSpinner color="white" /> : 'Continue'}
    </Button>
  );
};

const styles = StyleSheet.create({
  container: {
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    marginVertical: spacing[3],
  },
  portraitContainer: {
    flexDirection: 'column',
    gap: spacing[2],
  },
  landscapeContainer: {
    flexDirection: 'row',
  },
  text: {
    textAlign: 'center',
  },
  portraitButtonContainer: {
    flexDirection: 'row',
    justifyContent: 'space-around',
    width: '100%',
  },
});
